exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-34819bbc]{width:100%;text-align:center;color:#000;margin-bottom:40px}.btn.ch2-inactive[data-v-34819bbc]{opacity:.5}", ""]);

// exports
